import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IReduxState } from "../../../store";
import { ADMIN_SERVER_BASE_URL, apiClient } from "../../../util/apiClient";
import CommonAlert from "../../Common/CommonAlert";
import MyDialogComponent from "../../Common/MyDialogComponent";
import EditForm from "../Module/EditForm";
import Formulaire from "./Formulaire";
import {
  addSousModules,
  editSousModule,
  setObjSousModule,
  setOpenDialog,
  setValueEdit,
  setValueComboEdit,
} from "./sousModuleSlice";

const AddSousModule = () => {
  //redux
  const dispatch = useDispatch();
  const { objModule, modules } = useSelector(
    (state: IReduxState) => state.module
  );
  const { openDialog, objSousModule, valueEdit, valeurComboEdit } = useSelector(
    (state: IReduxState) => state.sousModule
  );

  //hooks
  const [valueSousModule, setValueSousModule] = useState("");
  const [openAlert, setOpenAlert] = useState(false);

  const handleSave = async () => {
    try {
      const apiPayload = {
        idModule: objModule.idModule,
        libelleSousModule: valueSousModule,
      };
      const res: any = await apiClient.post(
        ADMIN_SERVER_BASE_URL,
        "/tablesystem/creersousmodule",
        apiPayload
      );
      if (res.status === 1) {
        const newSousModule = {
          ...res.data,
          id: res.data.idSousModule,
          libelle: res.data.libelleSousModule,
        };
        dispatch(addSousModules(newSousModule));
        dispatch(setOpenDialog(false));
      } else {
        console.log("status !==1");
      }
    } catch (error) {
      console.log(
        "🚀 ~ file: AddSousModule.tsx ~ line 51 ~ handleSave ~ error",
        error
      );
    }
  };

  const editItem = async () => {
    try {
      const apiPayload = {
        idSousModule: objSousModule.idSousModule,
        libelleSousModule: valueEdit,
      };
      const res: any = await apiClient.post(
        ADMIN_SERVER_BASE_URL,
        "/tablesystem/modifiersousmodule",
        apiPayload
      );
      if (res.status === 1) {
        const newSousModule = {
          ...res.data,
          id: res.data.idSousModule,
          libelle: res.data.libelleSousModule,
        };
        dispatch(editSousModule(newSousModule));
        dispatch(setOpenDialog(false));
      } else {
        console.log("status !==1");
      }
    } catch (error) {
      console.log(
        "🚀 ~ file: AddModule.tsx ~ line 51 ~ handleSave ~ error",
        error
      );
    }
  };

  const handleOpen = () => {
    //verifier si un module a été selectionné avant d'ouvir le dialog d'enreegistrement du sous module
    if (Object.keys(objModule).length > 0) {
      dispatch(setOpenDialog(true));
      dispatch(setObjSousModule({}));
      setValueSousModule("");
    } else {
      setOpenAlert(true);
    }
  };

  const handleClose = () => {
    dispatch(setOpenDialog(false));
  };

  const handleAlertClose = () => {
    setOpenAlert(false);
  };

  return (
    <div>
      <MyDialogComponent
        dialogTitle={`${
          Object.keys(objSousModule).length > 0
            ? `Modifier ${objSousModule.libelleSousModule}`
            : `Créer un sous module`
        }`}
        // dialogTitle={`${Object.keys(objSousModule).length > 0 ? "Modifier" + " " + objSousModule.libelleSousModule : "Créer un sous module"}`}
        dialogContent={
          Object.keys(objSousModule).length > 0 ? (
            <EditForm
              setValueEdit={setValueEdit}
              valueEdit={valueEdit}
              setValueComboEdit={setValueComboEdit}
              valeurComboEdit={valeurComboEdit}
              data={modules}
              libelle="Sous module"
              libelleCombo="Module"
            />
          ) : (
            <Formulaire
              setValueSousModule={setValueSousModule}
              valueSousModule={valueSousModule}
            />
          )
        }
        handleSave={
          Object.keys(objSousModule).length > 0 ? editItem : handleSave
        }
        openDialog={openDialog}
        handleClose={handleClose}
        handleOpen={handleOpen}
      />
      <CommonAlert
        severity="warning"
        variant="filled"
        description="Veuillez selectionner un module."
        title="Alerte !"
        openAlert={openAlert}
        handleAlertClose={handleAlertClose}
      />
    </div>
  );
};

export default AddSousModule;
